import React from 'react';
import './ContactUs.css';
import config from '../../config';



const ContactUs = () => {
  const sectionStyle = {
    // backgroundImage: `url(${config.pictureBg})`,
    // backgroundSize: 'cover',
    // backgroundPosition: 'center',
    height: '70px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    textAlign: 'center',
  };

  return (
    <div className="contact-us-section" style={sectionStyle}>
      <h1>Contact Us</h1>
      <div className="arrow">&#x25BC;</div>
    </div>
  );
};

export default ContactUs;